import React from "react";

const ApiDocs = () => {    
    return (
      <div className="swagger-container">
        <iframe
          src={`https://aae-backend-develop-c2gmbueye3gwcjc8.westus-01.azurewebsites.net/api-docs`}
          style={{
            width: '100%',
            height: '100vh',
            border: 'none'
          }}
          title="API Documentation"
        />
      </div>
    );
  };

export default ApiDocs;
